import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ImportTotalUosPatient } from '../models/import-total-uos.model';

@Injectable({
    providedIn: 'root'
  })
export class TotalUosImportService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/TotalUos/";
    }

    async getTotalUosImportRawData(costCenterId: number, startDate: Date, endDate: Date): Promise<ImportTotalUosPatient[]> {
        const params = new HttpParams()
        .set('costCenterId', costCenterId.toString())
        .set('startDate', startDate.toLocaleString())
        .set('endDate', endDate.toLocaleString());

    return await this._http.get<ImportTotalUosPatient[]>(`${this.apiServer}GetTotalUosImportRawData`, { params: params }).toPromise<ImportTotalUosPatient[]>();
    }
}